module.exports = __webpack_public_path__ + "img/026157EE-0557-4ea8-8BBB-E00CA5ED8DD7.cbce1159.png";